import { render, staticRenderFns } from "./Prioritization.vue?vue&type=template&id=4378f713&scoped=true"
import script from "./Prioritization.vue?vue&type=script&lang=js"
export * from "./Prioritization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4378f713",
  null
  
)

export default component.exports